import moment from 'moment';
import { getDtd, getFareType } from '../../../../utilities/helpers';
import { sendAncillaryAddToCartEvent } from '../../../../utilities/customer-io-ancillary-events';

export default (products, pnrModel, userProfile, isActiveFlowCorporate, userCorporate) => {
  const items = [];
  let tripType = 'MC';
  const segments = [];
  let zone = 'NA';
  const legCollection = pnrModel?.legCollection;
  const outboundSegments = legCollection?.[0]?.segmentsCollection;
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection;
  let fopType = '';
  let stopNumbers = 0;

  if (pnrModel?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrModel?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  if (legCollection.length > 0) {
    legCollection.forEach((element) => {
      const data = element?.segmentsCollection;
      stopNumbers = data?.length > 1 ? stopNumbers + (data?.length - 1) : stopNumbers;
      data.map((segmentsData) => {
        segments.push(segmentsData);
      });
    });
  }

  const seatData = [];
  products.forEach((element) => {
    const seats = element[0].products[0];
    seatData.push(seats);
  });

  const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
  const transactionDate = moment(pnrModel?.creationDate);
  const apiItem = apiDepartureDate.diff(transactionDate, 'days');
  const dtd = getDtd(segments?.[0]?.departureDateTime);

  const inboundDepartureDate = pnrModel?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrModel?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';

  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';

  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}` || 'NA';
  }

  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const apItemRanges = [
    { min: 0, max: 2, range: '0 a 2' },
    { min: 3, max: 6, range: '3 a 6' },
    { min: 7, max: 13, range: '7 a 13' },
    { min: 14, max: 20, range: '14 a 20' },
    { min: 21, max: 27, range: '21 a 27' },
    { min: 28, max: 49, range: '28 a 49' },
    { min: 50, max: 89, range: '50 a 89' },
    { min: 90, max: 119, range: '90 a 119' },
    { min: 120, max: 149, range: '120 a 149' },
    { min: 150, max: Infinity, range: '150+' },
  ];

  const apItemRange = apItemRanges.find(({ min, max }) => apiItem >= min && apiItem <= max)?.range || 'NA';

  let msItem = 0;
  if (segments.length > 1) {
    const firstSegment = moment(segments?.[0]?.departureDateTime);
    const lastSegment = moment(segments?.[segments.length - 1]?.arrivalDateTime);
    msItem = tripType !== 'MC' ? lastSegment.diff(firstSegment, 'days') : 0;
  }

  let marketSegment = [];
  const marketTest = [];
  const bookingClassTest = [];
  const cabinClassTest = [];
  (legCollection || []).forEach((element) => {
    const segmentsInfo = element?.segmentsCollection;
    const tmpMarketSegmet = [];
    const bookingClass = [];
    const cabinClass = [];
    (segmentsInfo || []).forEach((segmentsData) => {
      tmpMarketSegmet.push(`${segmentsData?.departureAirport}${segmentsData?.arrivalAirport}`);
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    marketTest.push(tmpMarketSegmet.join('/'));
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  marketSegment = marketTest.join('-');
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');

  const travelerCollection = pnrModel?.cart?.travelerCollection || [];

  const ffNumber = userProfile?.ffNumber ? `${userProfile?.ffNumber}` : 'NA';
  let ffProgram = 'NA';
  travelerCollection.forEach(passenger => {
    if (passenger?.frequentFlyerNumber === ffNumber) {
      ffProgram = passenger?.frequentFlyerProgram;
    }
  });

  const seatAncillaries = pnrModel?.cart?.getAllUnPaidSegmentChoice();
  const seatAncillariesArray = seatAncillaries?.map((currentSeat) => ({ redeemedCP: currentSeat?.redeemedCP, commercialName: 'seat', type: currentSeat?.seat?.code, totalCPPoints: currentSeat?.seat?.currency?.totalCPPoints, total: currentSeat?.seat?.currency?.total, segmentCode: currentSeat?.segmentCode }));

  let fopTpeItem = 'Cash';
  let adultMinors = 0;
  let adults = 0;
  let child = 0;
  let infants = 0;
  travelerCollection.forEach(traveler => {
    if (traveler?.paxType === 'ADULT') {
      const dateOfBirth = moment(traveler?.dateOfBirth).format('YYYYMMDD');
      const currentAge = moment().diff(moment(dateOfBirth, 'YYYYMMDD'), 'years');
      if (currentAge >= 15 && currentAge < 18) {
        adultMinors = adultMinors + 1;
      } else {
        adults = adults + 1;
      }
    } else if (traveler?.paxType === 'CHILD') {
      child = child + 1;
    } else if (traveler?.paxType === 'INFANT') {
      infants = infants + 1;
    }
  });

  const corpProgram = isActiveFlowCorporate ? 'AM Rewards Business' : 'NA';
  let corpId = 'NA';
  const companySelected = userCorporate?.companySelected;
  (userCorporate?.companies?.companies || []).forEach(company => {
    corpId = company?.companyName === companySelected ? company?.companyLoyaltyNumber : corpId;
  });

  if (pnrModel?.globalMarketFlight === 'DOMESTIC') {
    zone = 'DOM';
  } else {
    zone = 'INT';
  }
  let totalPrice = 0;
  let totalPoints = 0;
  (seatData || []).forEach((product) => {
    const itemBrand = 'AM';
    const itemCategory = 'Ancillary';
    const seatTypes = ['AMPlus Seat', 'Emergency Exit Seat', 'Preferred Seat', 'Seat Choice'];
    const seat = seatTypes?.includes(product?.name);
    const itemAffiliation = 'AM';
    let itemCategory2 = 'NA';
    let itemCategory3 = 'NA';
    let price = 0;
    let points = 0;
    let quantity = 0;
    let itemListName = 'NA';
    const leg = product?.category;
    let currentAncillary = (seatAncillariesArray || []).find((produc) => produc?.type === product?.id);
    fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';

    if (seat) {
      itemCategory2 = 'Seat';
      itemCategory3 = product?.name + '|' + product?.id;
      price = product?.price;
      points = product?.points;
      quantity = product?.quantity;
      itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
        'Ancillaries outbound ancillaries inbound';
    }

    legCollection.forEach(legs => {
      (legs?.segmentsCollection || []).forEach((passenger, index) => {
        const departureDateTime = moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss');
        const flightTime = moment.utc(passenger?.flightDurationInMinutes * 60000).format('HH:mm');
        const brandFare = getFareType(passenger);
        const marketNdodItem = marketNdod;
        const marketOdItem = `${passenger?.departureAirport}${passenger?.arrivalAirport}`;
        const segment = passenger?.departureAirport + '-' + passenger?.arrivalAirport;
        const opCarrier = passenger?.operatingCarrier;
        const segmentCheck = leg?.includes(segment);
        itemListName = legs.itineraryPartType == 'OUTBOUND' ? 'Ancillaries outbound' : 'Ancillaries inbound';

        currentAncillary = (seatAncillariesArray || []).find((produc) => produc?.segmentCode === passenger?.segmentCode && produc?.type === product?.id);
        const isSameSegmentCode = passenger?.segmentCode === currentAncillary?.segmentCode;

        if (isSameSegmentCode) {
          fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';
          points = currentAncillary?.redeemedCP ? currentAncillary?.totalCPPoints : 0;
          price = currentAncillary?.redeemedCP ? 0 : currentAncillary?.total;
          const segmentPrice = fopTpeItem === 'Points' ? points : price;
          if (currentAncillary?.redeemedCP) {
            totalPoints = !isNaN(segmentPrice) ? totalPoints + segmentPrice : totalPoints;
          } else {
            totalPrice = !isNaN(segmentPrice) ? totalPrice + segmentPrice : totalPrice;
          }
        }

        if (pnrModel.isOnHold && legs.itineraryPartType === 'OUTBOUND') {
          itemListName = 'Flights outbound';
          itemListName = tripType == 'MC' ? 'Flights outbound' : itemListName;
        } else if (pnrModel.isOnHold && legs.itineraryPartType === 'INBOUND') {
          itemListName = 'Flights inbound';
          itemListName = tripType == 'MC' ? 'Flights outbound' : itemListName;
        }
        
        const seatCheck = seat ? false : legs?.legType === 'CONNECTING';
        if (segmentCheck || seatCheck) {
          const params = {
            'item_name': marketOdItem || 'NA',
            'coupon': 'NA',
            'discount': 0,
            'item_brand': itemBrand,
            'item_category': itemCategory,
            'item_category2': itemCategory2,
            'item_category3': itemCategory3,
            'item_list_name': itemListName,
            'item_affiliation': itemAffiliation,
            'price': price,
            'quantity': quantity,
            'index': index,
            'market_ndod_item': marketNdodItem || 'NA',
            'market_od_item': marketOdItem || 'NA',
            'market_segment_item': marketOdItem || 'NA',
            'zone_item': passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT' || 'NA',
            'region_item': passenger?.regionKeyFromLeg || 'NA',
            'flight_time_dep': departureDateTime || 'NA',
            'flight_time': flightTime || 'NA',
            'branded_fare': brandFare,
            'upsell_amount': 0,
            'outbound_departure_date_item': outboundDepartureDate || 'NA',
            'inbound_departure_date_item': inboundDepartureDate,
            'fop_type_item': fopTpeItem,
            'price_points': points || 0,
            'airport_tax': pnrModel?.cart?.total?.taxDetails?.TUA || 0,
            'aircraft_type': passenger?.aircraftType || 'NA',
            'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
            'ap_item': apItemRange,
            'ms_item': msItem,
            'cabin_item': passenger?.cabin || 'NA',
            'class_item': passenger?.bookingClass || 'NA',
          };
          items.push(params);
        }
      });
    });
  });

  const updatedItems = items.filter((obj, index, item) =>
    index === item.findIndex((value) => (
      value?.price === obj?.price && value?.item_name === obj?.item_name && value?.item_category3 === obj?.item_category3 && value?.flight_time
      === obj?.flight_time
    ))
  );

  if (totalPoints > 0 && totalPrice > 0) {
    fopType = 'Cash+Points';
  } else if (totalPoints > 0 && totalPrice === 0) {
    fopType = 'Points';
  } else {
    fopType = 'Cash';
  }

  const result = {
    event: 'add_to_cart',
    ecommerce: {
      'currency': products?.currencyCode || pnrModel?.cart?.total?.currencyCode || 'NA',
      'value': totalPrice,
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Ancillary',
      'trip_type': tripType,
      'fop_type': fopType || 'NA',
      'outbound_departure_date': outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone,
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegment || 'NA',
      'region': legCollection?.[0]?.regionKey || 'NA',
      'value_points': totalPoints,
      'ffn_program': ffProgram,
      'ffn_id': ffNumber,
      'corp_program': corpProgram,
      'corp_id': corpId || 'NA',
      'adults': adults,
      'childs': child,
      'infants': infants,
      'adult_minor': adultMinors,
      'stops_number': stopNumbers,
      'dtd': dtd,
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': (legCollection?.[0]?.legType === 'CONNECTING' || legCollection?.[legCollection?.length - 1]?.legType === 'CONNECTING') ? updatedItems : items,
    },
  };

  // Customer.io ancillary_addtocart event integration
  try {
    sendAncillaryAddToCartEvent({
      ancillaryType: 'seatselection',
      PNR: pnrModel?.pnrCode || 'Unknown',
      passengerName: pnrModel?.cart?.travelerCollection?.[0]?.firstName || '',
      passengerLastName: pnrModel?.cart?.travelerCollection?.[0]?.lastName || '',
      email: pnrModel?.cart?.travelerCollection?.[0]?.email || '',
      phone: pnrModel?.cart?.travelerCollection?.[0]?.phone || '',
      destination: legCollection?.[0]?.segmentsCollection?.[0]?.arrivalAirport || 'Unknown',
    });
  } catch (error) {
    // Silent error
  }

  return result;
};
